import { r, s } from "./api-base-asia";
export const apiAsia = {
  testDrive: {
    submit: r("POST sitecore/driver/ClueAdd"),
    get: r("GET sitecore/driver/getcartypes")
  },
  testDriveV2: {
    submit: r("POST sitecore/driver/LeadsAdd"),
    submitLeadsData: r("POST sitecore/driver/LeadsDataAdd")
  },
  consent: {
    check: r("GET sitecore/core/checkstate"),
    submit: r("GET sitecore/core/submitoperation")
  },
  dealer: {
    countries: r("GET sitecore/driver/country"),
    cities: r("GET sitecore/driver/city"),
    search: r("GET sitecore/driver/query"),
    getCountryCode: r("GET sitecore/country/GetCountry")
  },
  waterFall: {
    like: r("GET sitecore/Thumbs/Do"),//cookieCode=20220628&itemId=123&cancel=true
    list: r("POST sitecore/Thumbs/GetThumbsSummariesByItemIds"),
    isLike: r("GET sitecore/Thumbs/GetThumbsDetailsByCode"),//cookieCode=20220628&cancel=true
  },
  contact: r("POST sitecore/comment/save"),
  sitecore: {
    item: r("GET sitecore/core/item")
  },
  news: {
    list: r("GET asia/sc/1.0/news/list"),
    medialist: r("GET asia/sc/1.0/medias/list")
  },
  form: {
    country: r("GET sitecore/country/Countries"),
    area: r("GET sitecore/country/Regions"),
    city: r("GET sitecore/country/Cities"),
    ip: r("GET sitecore/country/QueryPhoneCode"),
    dealer: r("GET sitecore/driver/QueryDealers"),
    countryCode: r("GET sitecore/country/QueryCountryCode"),
    submit: s("POST sitecore/sub/submit"),
    unbind: r("POST asia/sc/1.0/subscribe/unbind"),
    bind: r("POST asia/sc/1.0/subscribe/bind"),
    visit: r("GET asia/sc/1.0/common/subscribe/visit"),
    check: r("POST asia/sc/1.0/subscribe/check"),
  },
  subscribe: {
  }
};